import moment from "moment"

const EQUIPMENT_REQUEST_STATUS_CHOICES = {
    S: 'Submitted',
    A: 'Approved',
    H: 'Shipped'
}

export function cleanRequestsData(requests) {

    return requests.map(request => {
        return {
            ...request,
            date: moment(request.datetimeCreated).format("MM/DD/YYYY"),
            requestedBy: request.requestedBy ? `${request.requestedBy.firstName} ${request.requestedBy.lastName}` : "",
            numItems: request.equipmentRequestItemsForEquipmentRequest.length,
            status: EQUIPMENT_REQUEST_STATUS_CHOICES[request.status],
            dateFullfilled: request.datetimeFulfilled ? moment(request.datetimeFulfilled).format("M/D/YYYY") : ''
        }
    })
}